import React from 'react'
import Select, { components } from 'react-select'
import classNames from 'classnames'
import './style.css'

const JourneysDropdown = ({journeys, selectedJourneyId, onChange, dark = false}) => {
  const colourStyles = {
    control: () => ({}),
    option: (styles) => {
      // eslint-disable-next-line
      const { color, backgroundColor, ":active": { backgroundColor: activeBackgroundColor }, ...rest } = styles
      return { ...rest }
    },
    valueContainer: styles => ({ ...styles, overflow: 'visible'})
  }

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <img alt="" src="/assets/rf-dropdown-arrows.svg" className="rf-dropdown-icon" />
      </components.DropdownIndicator>
    )
  }

  const SingleValue = ({ children, ...props }) => (
    <components.SingleValue {...props}>
      <div className="rf-journey-dropdown__value">{children}</div>
    </components.SingleValue>
  )

  return (
    <Select
      className={classNames('rf-journey-dropdown', {'dark': dark})}
      styles={colourStyles}
      components={{ DropdownIndicator, SingleValue }}
      classNamePrefix="rf-journey-dropdown"
      placeholder="Seleccione una jornada"
      options={journeys}
      isClearable={false}
      isSearchable={false}
      value={selectedJourneyId && journeys.find(option => option.value === selectedJourneyId)}
      onChange={onChange} />
  )
}

export default JourneysDropdown
